// test2352
(2352 && 0);
